import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import ModalDetalleMotivos from './ModalDetalleMotivos'

import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
function TablaProducto(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_09certificadosMap = props.certificadosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleCertificado, handdleRemovecertificadosPrev, handdleEditcertificadosPrev, certificados } = api
    const [id, setId] = React.useState()
    const [tipocertificado, settipocertificado] = React.useState('')
    const [numerocertificado, setNumeroCertificado] = React.useState('')
    const [vencimientocertificado, setVencimientoCertificado] = React.useState(false)
    const [cambioaduana, setCambioAduana] = React.useState(false)
    const [especificaraduana, setAduana] = React.useState('')
    const [cambiocatidad, setCambioCantidadProducto] = React.useState(false)
    const [especificarcantidad, setCantidadProducto] = React.useState('')
    const [cambiodestinatario, setCambioDestintario] = React.useState(false)
    const [especificardestinatario, setDestintario] = React.useState('')
    const [domicilioimportador, setCambioDomicilio] = React.useState(false)
    const [especificardomicilio, setDomicilio] = React.useState('')
    const [otros, setOtros] = React.useState(false)
    const [especificarotros, setEspecificarOtros] = React.useState('')

    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = [
        {
            field: 'tipocertificado', headerName: 'Tipo certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.8,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipocertificado == 'Exportacion' ? 'Exportación' : params.row.tipocertificado == 'Exportacion promocion' ? 'Exportación promoción' : params.row.tipocertificado}`} arrow>
                        <label>{`${params.row.tipocertificado == 'Exportacion' ? 'Exportación' : params.row.tipocertificado == 'Exportacion promocion' ? 'Exportación promoción' : params.row.tipocertificado}`}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'numerocertificado', headerName: 'Número de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:1, },
        {
            field: 'motivo', headerName: 'Motivos', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.5,
            renderCell: (params) => (
                <Fragment>
                    <Fragment>
                        <button className={'btn btn-secondary ms-1'} onClick={() => { setDataDetalle(params.row), setDetalleMotivo(true) }} >Detalle</button>
                    </Fragment>
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.8,
            renderCell: (params) => (

                <Fragment>
                    {fc_09certificadosMap?.length > 0 ? (
                        <Fragment>

                            {/* // <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button> */}
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                        </Fragment>)}
                </Fragment>

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemovecertificadosPrev({ data: params.row })
    }

    const botonGuardar = async () => {
        if (tipocertificado.length > 0 && numerocertificado.length > 0 && (vencimientocertificado || (cambioaduana && especificaraduana.length > 1) ||
            (cambiocatidad && especificarcantidad.length > 0) || (cambiodestinatario && especificardestinatario.length > 0) ||
            (domicilioimportador && especificardomicilio.length > 0) || (otros && especificarotros.length > 0))) {
            let dato = {
                id: id, numerocertificado: numerocertificado, tipocertificado: tipocertificado,
                vencimientocertificado, cambioaduana, especificaraduana, cambiocatidad, especificarcantidad,
                cambiodestinatario, especificardestinatario, domicilioimportador, especificardomicilio,
                otros, especificarotros
            }
            handdleEditcertificadosPrev(dato)
            setNumeroCertificado('')
            settipocertificado('')
            setEditar(false)
            setproductoMap([])
            setVencimientoCertificado(false)
            setCambioAduana(false)
            setAduana('')
            setCambioCantidadProducto(false)
            setCantidadProducto('')
            setCambioDestintario(false)
            setDestintario('')
            setCambioDomicilio(false)
            setDomicilio('')
            setOtros(false)
            setEspecificarOtros('')
        } else {
            setvalidacion(true)
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setNumeroCertificado(params.row.numerocertificado)
        settipocertificado(params.row.tipocertificado)
        setVencimientoCertificado(params.row.vencimientocertificado)
        setCambioAduana(params.row.cambioaduana)
        setAduana(params.row.especificaraduana)
        setCambioCantidadProducto(params.row.cambiocatidad)
        setCantidadProducto(params.row.especificarcantidad)
        setCambioDestintario(params.row.cambiodestinatario)
        setDestintario(params.row.especificardestinatario)
        setCambioDomicilio(params.row.domicilioimportador)
        setDomicilio(params.row.especificardomicilio)
        setOtros(params.row.otros)
        setEspecificarOtros(params.row.especificarotros)

        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(certificados)
    let [isGranel, setIsGranel] = React.useState(false)
    let [isExportacion, setIsExportacion] = React.useState(false)
    React.useEffect(() => {
        setRows(certificados)
        let filtroGranel = certificados.filter(anexo => anexo.tipocertificado == 'Granel')
        let filtroExportacion = certificados.filter(anexo => anexo.tipocertificado == 'Exportacion')
        let filtroPromocion = certificados.filter(anexo => anexo.tipocertificado == 'Exportacion promocion')
        if (filtroGranel.length > 0) setIsGranel(true)
        else setIsGranel(false)
        if (filtroExportacion.length > 0 || filtroPromocion.length > 0) setIsExportacion(true)
        else setIsExportacion(false)
    }, [certificados])

    const botonAgregar = async () => {
        if (tipocertificado.length > 0 && numerocertificado.length > 0 && (vencimientocertificado || (cambioaduana && especificaraduana.length > 1) ||
            (cambiocatidad && especificarcantidad.length > 0) || (cambiodestinatario && especificardestinatario.length > 0) ||
            (domicilioimportador && especificardomicilio.length > 0) || (otros && especificarotros.length > 0))) {
            let dato = {
                id: uuidv4(), numerocertificado: numerocertificado, tipocertificado: tipocertificado,
                vencimientocertificado, cambioaduana, especificaraduana, cambiocatidad, especificarcantidad,
                cambiodestinatario, especificardestinatario, domicilioimportador, especificardomicilio,
                otros, especificarotros
            }
            handdleCertificado(dato)
            setNumeroCertificado('')
            settipocertificado('')
            setVencimientoCertificado(false)
            setCambioAduana(false)
            setAduana('')
            setCambioCantidadProducto(false)
            setCantidadProducto('')
            setCambioDestintario(false)
            setDestintario('')
            setCambioDomicilio(false)
            setDomicilio('')
            setOtros(false)
            setEspecificarOtros('')
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setNumeroCertificado('')
        settipocertificado('')
        setVencimientoCertificado(false)
        setCambioAduana(false)
        setAduana('')
        setCambioCantidadProducto(false)
        setCantidadProducto('')
        setCambioDestintario(false)
        setDestintario('')
        setCambioDomicilio(false)
        setDomicilio('')
        setOtros(false)
        setEspecificarOtros('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_09certificadosMap.filter(anexo => anexo.idfc08_anexorenovacion === params.row.idfc08_anexorenovacion)
        setproductoMap(filtro[0])
        if (params.row.idfc08_anexorenovacion) setId(params.row.idfc08_anexorenovacion)
        setNumeroCertificado(params.row.numerocertificado)
        settipocertificado(params.row.tipocertificado)
        setVencimientoCertificado(params.row.vencimientocertificado)
        setCambioAduana(params.row.cambioaduana)
        setAduana(params.row.especificaraduana)
        setCambioCantidadProducto(params.row.cambiocatidad)
        setCantidadProducto(params.row.especificarcantidad)
        setCambioDestintario(params.row.cambiodestinatario)
        setDestintario(params.row.especificardestinatario)
        setCambioDomicilio(params.row.domicilioimportador)
        setDomicilio(params.row.especificardomicilio)
        setOtros(params.row.otros)
        setEspecificarOtros(params.row.especificarotros)
        setEditar(true)
    }

    const [detalleMotivo, setDetalleMotivo] = React.useState(false)
    const [dataDetalle, setDataDetalle] = React.useState([])
    const VerModalDetalle = (objeto) => {
        setDetalleMotivo(objeto)
    }

    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>

                    <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-select ${productoMap?.certificadocheck !== undefined ? (
                                productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={tipocertificado} onChange={e => {
                                    settipocertificado(e.target.value)
                                    if (e.target.value == 'Granel') setVencimientoCertificado(true)
                                    else setVencimientoCertificado(false)
                                }}
                            >
                                <option value='0'>Tipo de certificado</option>
                                <option value="Granel" disabled={isExportacion}>Granel</option>
                                <option value="Exportacion" disabled={isGranel}>Exportación</option>
                                <option value="Exportacion promocion" disabled={isGranel}>Exportación promoción</option>
                            </select>
                            <label htmlFor='floatingInput'></label>
                            <span className='text-danger'>{productoMap?.certificadocheck ? productoMap?.certificado : ''}</span>
                            <span className='text-danger'>{tipocertificado.length <= 0 ? 'Campo Obligatorio' : ''}</span>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.certificadocheck !== undefined ? (
                                productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de certificado'
                                value={numerocertificado} onChange={e => setNumeroCertificado(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>N° de certificado</label>
                            <span className='text-danger'>{productoMap?.certificadocheck ? productoMap?.certificado : ''}</span>
                            <span className='text-danger'>{numerocertificado.length <= 0 ? 'Campo Obligatorio' : ''}</span>

                        </div>
                    </div>
                    <div className='row justify-content-start'>
                    </div>
                    <div className={`row  ${estilos.divSoloBorderNaranja}`} style={{ textAlign: 'start' }}>
                        <h6 className={`text-center ${estilos.labelNaranja}`}>MOTIVOS POR LOS CUALES SOLICITA LA RENOVACIÓN</h6>
                        <span className='text-danger text-center'>{productoMap?.certificadocheck ? productoMap?.certificado : ''}</span>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                            <input className={`form-check-input me-1 ${productoMap?.certificadocheck !== undefined ? (
                                productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                checked={vencimientocertificado} id='vencimientocertificado'
                                name="vencimientocertificado"
                                onChange={e => { setVencimientoCertificado(e.target.checked) }}
                            />
                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                Vencimiento de certificado.
                            </label><br />
                            <span className='text-danger'>{productoMap?.vencimientocertificadocheck ? productoMap?.vencimientocertificado : ''}</span>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'><br /></div>
                        {tipocertificado != 'Granel' &&
                            <Fragment>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                    <input className={`form-check-input me-1 ${productoMap?.certificadocheck !== undefined ? (
                                        productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                        checked={cambioaduana} id='cambioaduana'
                                        name="cambioaduana"
                                        onChange={e => { setCambioAduana(e.target.checked) }}
                                    />
                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                        Cambio de aduana.
                                    </label><br />
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                    {cambioaduana ?
                                        (<Fragment>
                                            <div className="form-floating mb-3">
                                                <select
                                                    name="especificaraduana"
                                                    value={especificaraduana}
                                                    onChange={e => setAduana(e.target.value)}
                                                    className={`form-select ${productoMap?.certificadocheck !== undefined ? (
                                                        productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} >
                                                    <option value="0" >ADUANA SALIDA</option>
                                                    <option value="AEROPUERTO INTERNACIONAL DE LA CIUDAD DE MÉXICO">AEROPUERTO INTERNACIONAL DE LA CIUDAD DE MÉXICO</option>
                                                    <option value="GUASCALIENTES, AGUASCALIENTES">AGUASCALIENTES, AGUASCALIENTES</option>
                                                    <option value="ALTAMIRA, TAMAULIPAS">ALTAMIRA, TAMAULIPAS</option>
                                                    <option value="CIUDAD HIDALGO, CHIAPAS">CIUDAD HIDALGO, CHIAPAS</option>
                                                    <option value="CIUDAD JUÁREZ, CHIHUAHUA">CIUDAD JUÁREZ, CHIHUAHUA</option>
                                                    <option value="COLOMBIA, NUEVO LEÓN">COLOMBIA, NUEVO LEÓN</option>
                                                    <option value="GUADALAJARA, JALISCO">GUADALAJARA, JALISCO</option>
                                                    <option value="GUANAJUATO, GUANAJUATO">GUANAJUATO, GUANAJUATO</option>
                                                    <option value="LÁZARO CÁRDENAS, MICHOACÁN">LÁZARO CÁRDENAS, MICHOACÁN</option>
                                                    <option value="MANZANILLO, COLIMA">MANZANILLO, COLIMA</option>
                                                    <option value="MEXICALI, BAJA CALIFORNIA">MEXICALI, BAJA CALIFORNIA</option>
                                                    <option value="MÉXICO, CIUDAD DE MÉXICO">MÉXICO, CIUDAD DE MÉXICO</option>
                                                    <option value="NOGALES, SONORA">NOGALES, SONORA</option>
                                                    <option value="NUEVO LAREDO, TAMAULIPAS">NUEVO LAREDO, TAMAULIPAS</option>
                                                    <option value="PIEDRAS NEGRAS, COAHUILA DE ZARAGOZA">PIEDRAS NEGRAS, COAHUILA DE ZARAGOZA</option>
                                                    <option value="TAMPICO, TAMAULIPAS">TAMPICO, TAMAULIPAS</option>
                                                    <option value="TIJUANA, BAJA CALIFORNIA">TIJUANA, BAJA CALIFORNIA</option>
                                                    <option value="TUXPAN, VERACRUZ">TUXPAN, VERACRUZ</option>
                                                    <option value="VERACRUZ, VERACRUZ">VERACRUZ, VERACRUZ</option>
                                                    <option value="PENDIENTE">PENDIENTE</option>
                                                </select>
                                                <label htmlFor='floatingInput'></label>
                                                <span className='text-danger'>{productoMap?.cambioaduanacheck ? productoMap?.cambioaduana : ''}</span>
                                                <span className='text-danger'>{especificaraduana <= 1 ? 'Campo Obligatorio' : ''}</span>
                                            </div>
                                        </Fragment>
                                        ) : ''

                                    }
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                    <input className={`form-check-input me-1 ${productoMap?.certificadocheck !== undefined ? (
                                        productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                        checked={cambiocatidad} id='cambioaduana' name="cambiocatidad"
                                        onChange={e => {
                                            setCambioCantidadProducto(e.target.checked)
                                            { e.target.checked == false && setCantidadProducto('') }
                                        }}
                                    />
                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                        Cambio de la cantidad del producto.
                                    </label><br />
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                    {cambiocatidad ?
                                        (<Fragment>
                                            <div className="form-floating mb-3">
                                                <textarea type="textarea" rows='10' className={`form-control ${productoMap?.certificadocheck !== undefined ? (
                                                    productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='especificarcantidad'
                                                    name="especificarcantidad"
                                                    value={especificarcantidad}
                                                    onChange={e => { setCantidadProducto(e.target.value) }}
                                                />
                                                <label htmlFor='floatingInput'>Especificar rango de hologramas a utilizar</label>
                                                <span className='text-danger'>{productoMap?.cambiocatidadcheck ? productoMap?.cambiocatidad : ''}</span>
                                                <span className='text-danger'>{especificarcantidad.length <= 0 && 'Campo Obligatorio'}</span>
                                            </div>
                                        </Fragment>) : ''}
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                    <input className={`form-check-input me-1 ${productoMap?.certificadocheck !== undefined ? (
                                        productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                        checked={cambiodestinatario} id='cambiodestinatario'
                                        name="cambiodestinatario"
                                        onChange={e => {
                                            setCambioDestintario(e.target.checked)
                                            { e.target.checked == false && setDestintario('') }
                                        }}
                                    />
                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                        Cambio de destinatario.
                                    </label><br />
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                    {cambiodestinatario ?
                                        (<Fragment>
                                            <div className="form-floating mb-3">
                                                <textarea type="textarea" rows='10' className={`form-control ${productoMap?.certificadocheck !== undefined ? (
                                                    productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='especificardestinatario'
                                                    name="especificardestinatario"
                                                    value={especificardestinatario}
                                                    onChange={e => { setDestintario(e.target.value) }}
                                                />
                                                <label htmlFor='floatingInput'>Especificar</label>
                                                <span className='text-danger'>{productoMap?.cambiodestinatariocheck ? productoMap?.cambiodestinatario : ''}</span>
                                                <span className='text-danger'>{especificardestinatario.length <= 0 && 'Campo Obligatorio'}</span>
                                            </div>
                                        </Fragment>
                                        ) : ''}
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                    <input className={`form-check-input me-1 ${productoMap?.certificadocheck !== undefined ? (
                                        productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                        checked={domicilioimportador} id='domicilioimportador'
                                        name="domicilioimportador"
                                        onChange={e => {
                                            setCambioDomicilio(e.target.checked)
                                            { e.target.checked == false && setDomicilio('') }
                                        }}
                                    />
                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                        Cambio de domicilio del importador.
                                    </label><br />
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                    {domicilioimportador ?
                                        (
                                            <Fragment>
                                                <div className="form-floating mb-3">
                                                    <textarea type="textarea" rows='10' className={`form-control ${productoMap?.certificadocheck !== undefined ? (
                                                        productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='especificardomicilio'
                                                        name="especificardomicilio"
                                                        value={especificardomicilio}
                                                        onChange={e => { setDomicilio(e.target.value) }}
                                                    />
                                                    <label htmlFor='floatingInput'>Especificar</label>
                                                    <span className='text-danger'>{productoMap?.domicilioimportadorcheck ? productoMap?.domicilioimportador : ''}</span>
                                                    <span className='text-danger'>{especificardomicilio.length <= 0 && 'Campo Obligatorio'}</span>
                                                </div>
                                            </Fragment>
                                        ) : ''}
                                </div>
                            </Fragment>
                        }
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                            <input className={`form-check-input me-1 ${productoMap?.certificadocheck !== undefined ? (
                                productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                checked={otros} id='otros'
                                name="otros"
                                onChange={e => {
                                    setOtros(e.target.checked)
                                    { e.target.checked == false && setEspecificarOtros('') }
                                }}
                            />
                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                Otros.
                            </label><br />
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                            {otros ? (
                                <Fragment>
                                    <div className="form-floating mb-3">
                                        <textarea type="textarea" rows='10' className={`form-control ${productoMap?.certificadocheck !== undefined ? (
                                            productoMap?.certificadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                            id="" placeholder='especificarotros'
                                            name="especificarotros"
                                            value={especificarotros}
                                            onChange={e => { setEspecificarOtros(e.target.value) }}
                                        />
                                        <label htmlFor='floatingInput'>Especificar</label>
                                        <span className='text-danger'>{productoMap?.otroscheck ? productoMap?.otros : ''}</span>
                                        <span className='text-danger'>{especificarotros.length <= 0 && 'Campo Obligatorio'}</span>
                                    </div>
                                </Fragment>
                            ) : ''}
                        </div>
                        {(vencimientocertificado == false && cambioaduana == false && cambiocatidad == false &&
                            cambiodestinatario == false && domicilioimportador == false && otros == false) && <span className='text-danger'>Debe de seleccionar una opción</span>}
                    </div>
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_09certificadosMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={() => botonAgregar()}>Agregar certificado</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar certificado</button>
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '100%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            {detalleMotivo && <ModalDetalleMotivos api={{ VerModalDetalle, dataDetalle, detalleMotivo }} />}

        </>
    )

}
export default TablaProducto